import { redirect, createFileRoute } from '@tanstack/react-router'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/logout')({
  beforeLoad: async () => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      return oidc.logout({ redirectTo: 'home' })
    }

    return redirect({ to: '/' })
  },
})
